export default "__VITE_ASSET__D6biTCl7__"